// src/components/Branch/config/sections/AwardsSection.jsx
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { StarIcon, PlusIcon, PencilIcon, TrashIcon, CheckCircleIcon } from "@heroicons/react/outline";
import { addAwardThunk, updateAwardThunk, deleteAwardThunk } from "../../../../store/thunks/branchDisplayThunks";
import Dropdown from "../../../common/Dropdown";

const AWARD_TYPES = [
  { _id: "INDUSTRY", name: "Industry Award" },
  { _id: "BUSINESS", name: "Business Award" },
  { _id: "DESIGN", name: "Design Award" },
  { _id: "SERVICE", name: "Service Excellence" },
  { _id: "CUSTOMER_CHOICE", name: "Customer Choice" },
  { _id: "REGIONAL", name: "Regional Award" },
  { _id: "OTHER", name: "Other" },
];

const AwardsSection = ({ branchCode, isRootAdmin }) => {
  const dispatch = useDispatch();
  const { awards, loadingSection } = useSelector((state) => state.branchDisplay);
  const [isAdding, setIsAdding] = useState(false);
  const [formData, setFormData] = useState({ type: "", title: "", year: "", issuedBy: "", description: "" });

  const handleAdd = async () => {
    const form = new FormData();
    Object.entries(formData).forEach(([k, v]) => form.append(k, v));
    await dispatch(addAwardThunk({ branchCode, formData: form }));
    setIsAdding(false);
    setFormData({ type: "", title: "", year: "", issuedBy: "", description: "" });
  };

  const handleDelete = async (awardId) => {
    if (window.confirm("Delete this award?")) {
      await dispatch(deleteAwardThunk({ branchCode, awardId }));
    }
  };

  return (
    <div className="space-y-6">
      {isRootAdmin && !isAdding && (
        <button onClick={() => setIsAdding(true)} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2">
          <PlusIcon className="h-4 w-4" /> Add Award
        </button>
      )}
      {isAdding && (
        <div className="bg-white border rounded-lg p-4 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <Dropdown label="Type" options={AWARD_TYPES} selected={AWARD_TYPES.find(t => t._id === formData.type)} onChange={s => setFormData(p => ({...p, type: s?._id || ""}))} />
            <div><label className="block text-sm text-gray-600 mb-1">Title *</label><input type="text" value={formData.title} onChange={e => setFormData(p => ({...p, title: e.target.value}))} className="w-full px-3 py-2 border rounded-lg" /></div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div><label className="block text-sm text-gray-600 mb-1">Year</label><input type="number" value={formData.year} onChange={e => setFormData(p => ({...p, year: e.target.value}))} className="w-full px-3 py-2 border rounded-lg" /></div>
            <div><label className="block text-sm text-gray-600 mb-1">Issued By</label><input type="text" value={formData.issuedBy} onChange={e => setFormData(p => ({...p, issuedBy: e.target.value}))} className="w-full px-3 py-2 border rounded-lg" /></div>
          </div>
          <div className="flex gap-2">
            <button onClick={handleAdd} disabled={!formData.title} className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 flex items-center gap-2"><CheckCircleIcon className="h-4 w-4" /> Add</button>
            <button onClick={() => setIsAdding(false)} className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg">Cancel</button>
          </div>
        </div>
      )}
      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="font-medium mb-4 flex items-center"><StarIcon className="h-4 w-4 mr-2" /> Awards ({awards.length})</h4>
        {awards.length === 0 ? <p className="text-center py-8 text-gray-500">No awards added</p> : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {awards.map(award => (
              <div key={award._id} className="bg-white border rounded-lg p-4 flex justify-between items-start">
                <div>
                  <h5 className="font-medium">{award.title}</h5>
                  <p className="text-sm text-gray-500">{award.year} • {award.issuedBy}</p>
                </div>
                {isRootAdmin && <button onClick={() => handleDelete(award._id)} className="p-1 text-red-600 hover:bg-red-50 rounded"><TrashIcon className="h-4 w-4" /></button>}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AwardsSection;
